import { Loading } from '@cibo/profile'
import { useLocation } from 'react-router-dom'
import { useInventories } from '../../../../features/Inventories'
import { SCOPE_THREE_ROUTES } from '../../../../navigation/types/scopeThreeRoutes'
import { InventoriesLayout } from '../InventoriesLayout'
import { InventoriesList } from './InventoriesList'
import { NoInventories } from './NoInventories'

export const InventoriesIndex = () => {
  const { pathname } = useLocation()
  const { data: inventories, isLoading } = useInventories()
  if (isLoading) {
    return <Loading large />
  }
  if ((!inventories || inventories?.items.length === 0) && pathname !== SCOPE_THREE_ROUTES.CREATE) {
    return <NoInventories />
  }
  if (
    inventories?.items.length &&
    inventories?.items.length > 0 &&
    pathname === SCOPE_THREE_ROUTES.ROOT
  ) {
    return <InventoriesList />
  }

  return <InventoriesLayout />
}
